// src/constants/Inventory/adjustmentConstants.js
export const ADJUSTMENT_ADD_REQUEST = "ADJUSTMENT_ADD_REQUEST";
export const ADJUSTMENT_ADD_SUCCESS = "ADJUSTMENT_ADD_SUCCESS";
export const ADJUSTMENT_ADD_FAIL = "ADJUSTMENT_ADD_FAIL";

export const ADJUSTMENT_LIST_REQUEST = "ADJUSTMENT_LIST_REQUEST";
export const ADJUSTMENT_LIST_SUCCESS = "ADJUSTMENT_LIST_SUCCESS";
export const ADJUSTMENT_LIST_FAIL = "ADJUSTMENT_LIST_FAIL";
